module.exports = __webpack_public_path__ + "static/media/13.66059587.webp";